<template>
    <div class="container">
      <section class="section">
        <h1 class="title"> Уважаемый (-ая)<span v-if="username">, {{ username }} </span> </h1>
        <h2 class="subtitle" style="text-align: justify; text-justify: inter-word;">
          <ul>
            Для открытия полного доступа к функционалу Личного Кабинета Вам необходимо:
            <li><i class="el-icon-check" style="padding-right:10px"></i>Пройти пробное тестирование;</li>
            <li><i class="el-icon-check" style="padding-right:10px"></i>Набрать минимум 50% правильных ответов.</li>
          </ul>
        </h2>
        <br>
        <label class="label">Начните пробное тестирование, нажав кнопку "<b>Вперёд</b>"</label>
        <div class="control">
          <el-col :span="3">
            <el-button class="button" type="info" v-on:click="start"><span>Вперёд</span></el-button>
          </el-col>
        </div>
      </section>
    </div>
</template>

<script>
  import config from '../../appsettings.js'
  export default {
    name: 'contestwelcome',
    data() {
      return {
        username: ''
      }
    },
    methods: {
      start() {
        this.$router.push(config.SCENARIO_WELCOME_URL);
      }
    },
    created() {
      this.$manager.getUser().then(user => {
        if (user) {
          this.username = user.profile.given_name;
        } else {
          this.username = '';
        }
      });
    }
  }
</script>

<style scoped>

  .button {
    display: inline-block;
    vertical-align:middle;
    border-radius: 4px;
    background-color: #50bfff;
    border: none;
    color: #FFFFFF;
    text-align: center;
    font-size: 20px;
    padding: 8px;
    width: 100%;
    transition: all 0.5s;
    cursor: pointer;
    margin: 5px;
  }

  .button span {
    cursor: pointer;
    display: inline-block;
    position: relative;
    transition: 0.5s;
  }

  .button span:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    top: 0;
    right: -20px;
    transition: 0.5s;
  }

  .button:hover span {
    padding-right: 25px;
  }

  .button:hover span:after {
    opacity: 1;
    right: 0;
  }

  ul {
    list-style-type: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/contest/welcome.vue